export const selectUserDetails = (state) => state.user.userDetails;
export const selectRoleUpdated = (state) => state.user.roleUpdated;
export const selectNotificationData = (state) => state.user.notificationData;
export const selectUserExploToken = (state) => state.user.exploToken;
export const selectPosPlatforms = (state) => state.user.posPlatform;
